import { Languages, Globe, Target } from "lucide-react";
import { useLanguage } from "@/contexts/LanguageContext";
import { useFadeIn, useStaggeredFadeIn } from "@/hooks/useFadeIn";

const DifferentiatorsSection = () => {
  const { t } = useLanguage();
  const { ref: headerRef, isVisible: headerVisible } = useFadeIn();
  const { ref: gridRef, isVisible: gridVisible, getItemDelay } = useStaggeredFadeIn(3, 0, 150);
  const { ref: ctaRef, isVisible: ctaVisible } = useFadeIn({ delay: 400 });

  const differentiators = [
    {
      icon: Languages,
      titleKey: "diff.multilingual.title",
      subtitleKey: "diff.multilingual.subtitle",
      descriptionKey: "diff.multilingual.description",
    },
    {
      icon: Globe,
      titleKey: "diff.nationwide.title",
      subtitleKey: "diff.nationwide.subtitle",
      descriptionKey: "diff.nationwide.description",
    },
    {
      icon: Target,
      titleKey: "diff.strategic.title",
      subtitleKey: "diff.strategic.subtitle",
      descriptionKey: "diff.strategic.description",
    },
  ];

  return (
    <section className="section-padding bg-navy-radial text-white">
      <div className="container-custom">
        {/* Section Header */}
        <div
          ref={headerRef}
          className={`text-center max-w-2xl mx-auto mb-16 fade-up ${headerVisible ? 'visible' : ''}`}
        >
          <span className="eyebrow-text">
            {t("diff.label")}
          </span>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-white mt-3 mb-4">
            {t("diff.title")}
          </h2>
        </div>

        {/* Differentiators Grid */}
        <div ref={gridRef} className="grid md:grid-cols-3 gap-8 lg:gap-12">
          {differentiators.map((item, index) => (
            <div
              key={item.titleKey}
              className={`text-center fade-up ${gridVisible ? 'visible' : ''}`}
              style={{ transitionDelay: `${getItemDelay(index)}ms` }}
            >
              {/* Icon Container */}
              <div className="relative inline-flex items-center justify-center mb-6">
                <div className="w-20 h-20 bg-gold/10 rounded-full flex items-center justify-center">
                  <item.icon className="w-9 h-9 text-gold" />
                </div>
              </div>

              {/* Content */}
              <h3 className="text-xl font-heading font-semibold text-white mb-1">
                {t(item.titleKey)}
              </h3>
              <span className="text-gold text-sm font-medium mb-4 block">
                {t(item.subtitleKey)}
              </span>
              <p className="text-white/70 text-sm leading-relaxed max-w-xs mx-auto">
                {t(item.descriptionKey)}
              </p>
            </div>
          ))}
        </div>

        {/* CTA */}
        <div
          ref={ctaRef}
          className={`text-center mt-16 fade-up ${ctaVisible ? 'visible' : ''}`}
        >
          <a href="#contact" className="btn-gold text-base px-8 py-4 whitespace-nowrap">
            {t("diff.cta")}
          </a>
        </div>
      </div>
    </section>
  );
};

export default DifferentiatorsSection;
